<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth <= 768" />
		<div class="max_view">
			<b-container fluid>
				<img class="top_img" width="100%"
					:src="windowWidth > 768 ? '../../static/img/function/top_img.png' : '../../static/img/function/top_img1.png'" />
			</b-container>
			<div class="mianbao" toggleable="lg" :class="{ isFixed: isFixed }">
				<div class="mianbao_view" v-if="windowWidth > 768">
					<div v-for="(item, index) in mianbaoList" :key="index" class="mianbao_item" @click="goAnchor(index)"
						:class="{ active: index == i }">{{ item.label }}</div>
				</div>
				<div class="mianbao_min" v-else>
					<div v-for="(item, index) in mianbaoList" :key="index" :class="{ active: index == i }"
						@click="goAnchor(index)">{{ item.label }}</div>
				</div>
			</div>

			<!--房车露营-->
			<div id="title1" v-if="i == 0">
				<div class="function" v-if="windowWidth > 768">
					<img width="700" height="700" :src="FCLYData.dzyList[lineCur].images" alt="700*700"
						v-if="FCLYData.dzyList && FCLYData.dzyList.length > 0" />
					<div class="functionRight">
						<div class="flex flex-row align-center justify-between">
							<h4 class="text-222">定制线路游</h4>
							<div class="flex flex-row text-666">
								<div class=" margin-left-xl">
									<p class="text-df" style="margin-bottom: 2px;">1000+</p>
									<p class="">定制线路(次)</p>
								</div>
								<div class=" margin-left-xl">
									<p class="text-df" style="margin-bottom: 2px;">10000+</p>
									<p class="">服务用户(人)</p>
								</div>
								<div class=" margin-left-xl">
									<p class="text-df" style="margin-bottom: 2px;">2000+</p>
									<p class="">累计出行(次)</p>
								</div>
							</div>
						</div>
						<div class=" margin-top-lg">
							<!-- <div class="lineBox text-center" :style="{ backgroundColor: lineBgColor[index] }"
								v-for="(item, index) in  FCLYData.dzyList  " :key="index" style="cursor: pointer;"
								@click="lineCur = index" v-if="index < 5">
								<img width="88" height="88" :src="item.cover" />
								<div class="text-666">{{ item.title }}</div>
							</div> -->

							<div style="position: relative; max-width: 550px;margin-left: 70px;">
								<Swiper class="swiper" :options="swiperOption0">
									<swiper-slide class="lineBox" v-for="(item, index) in  FCLYData.dzyList  " :key="index"
										style="cursor: pointer;">
										<div class="lineBox text-center" :style="{ backgroundColor: lineBgColor[index] }"
											@click="lineCur = index">
											<img width="88" height="88" :src="item.cover" />
											<div class="text-666">{{ item.title }}</div>
										</div>
									</swiper-slide>
								</Swiper>
								<div class="swiperBtn0">
									<div class="swiper-button-prev"
										style="width: 60px;height: 150px;background-color: #F2F3F5;" slot="button-prev">
									</div>
									<div class="swiper-button-next"
										style="width: 60px;height: 150px;background-color: #F2F3F5;" slot="button-next">
									</div>
								</div>
							</div>
						</div>
						<div class="text-xs text-222 text-left" style="margin-top: 50px;">
							定制游功能介绍
						</div>
						<div class="text-left" style="width: 59px;height: 3px;background-color: #0C8C69;margin-top: 20px;">
						</div>
						<p class="text-222 text-left" style="margin-top: 40px;">
							约你游定制线路游提供个人/团体的个性化需求服务，根据客户需求实施线路方案设计，以客户为主导进行，行程安排个性化、私密化、自由化，一人成团，房车随行。</p>
						<img width="920" style="margin-right: -240px;margin-top: 100px;"
							src="../../static/img/function/ic_img.png" />
					</div>
				</div>

				<div class="function margin-top padding-lr-sm" v-else>
					<h4 class="text-222">定制线路游</h4>
					<div class="flex flex-row align-center justify-around text-666 margin-top-sm">
						<div class="">
							<p class="" style="font-size: 20px;margin-bottom: 1px;">1000+</p>
							<p class="text-666" style="font-size: 12px;">定制线路(次)</p>
						</div>
						<div class="">
							<p class="" style="font-size: 20px;margin-bottom: 1px;">10000+</p>
							<p class="text-666" style="font-size: 12px;">服务用户(人)</p>
						</div>
						<div class="">
							<p class="" style="font-size: 20px;margin-bottom: 1px;">2000+</p>
							<p class="text-666" style="font-size: 12px;">累计出行(次)</p>
						</div>
					</div>
					<img class="margin-top-xs" width="98%" height="345" :src="FCLYData.dzyList[lineCur].images"
						alt="700*700" v-if="FCLYData.dzyList && FCLYData.dzyList.length > 0" />
					<div class="functionRight">
						<!-- <div class="flex flex-row margin-top-sm justify-around">
							<div class="lineBox text-center"
								:class="lineCur == index ? 'lineBox_active' : 'lineBox_noactive'"
								:style="{ backgroundColor: lineBgColor[index] }"
								v-for="(item, index) in  FCLYData.dzyList  " :key="index" style="cursor: pointer;"
								@click="lineCur = index" v-if="index < 5">
								<img width="44" height="44" :src="item.cover" />
								<div class="text-666" style="font-size: 12px;">{{ item.title }}</div>
							</div>
						</div> -->

						<div class="margin-top-xs">
							<Swiper class="swiper" :options="swiperOption0">
								<swiper-slide v-for="(item, index) in  FCLYData.dzyList  " :key="index"
									style="cursor: pointer;">
									<div class="lineBox text-center"
										:class="lineCur == index ? 'lineBox_active' : 'lineBox_noactive'"
										:style="{ backgroundColor: lineBgColor[index] }" @click="lineCur = index">
										<img width="44" height="44" :src="item.cover" />
										<div class="text-666" style="font-size: 12px;">{{ item.title }}</div>
									</div>
								</swiper-slide>
							</Swiper>
						</div>

						<div class="text-xs text-222 text-left margin-top">
							定制游功能介绍
						</div>
						<div class="text-left" style="width: 59px;height: 3px;background-color: #0C8C69;margin-top: 20px;"
							v-if="windowWidth > 768">
						</div>
						<div class="text-left" style="width: 59px;height: 3px;background-color: #0C8C69;margin-top: 10px;"
							v-else>
						</div>
						<p class="text-222 text-left" style="margin-top: 20px;">
							约你游定制线路游提供个人/团体的个性化需求服务，根据客户需求实施线路方案设计，以客户为主导进行，行程安排个性化、私密化、自由化，一人成团，房车随行。</p>
						<!-- <img width="920" style="margin-right: -240px;margin-top: 100px;"
							src="../../static/img/function/ic_img.png" /> -->
					</div>
				</div>

				<div class="themeView" v-if="windowWidth > 768">
					<h4>主题游玩</h4>
					<p>约你游主题活动旨在满足团体聚会/生日派对/企业团建/家庭活动/亲子研学等不同应用场景下的游玩需求，无论是短途、周边、省内或是国内、国际出游，约你游均可提供不同类型的房旅解决方案。</p>
					<div class="themeView_box">
						<div class="swiperView">
							<Swiper class="my-swipe swiper themeImg_box" :options="swiperOption">
								<swiper-slide v-for="(item, index) in  FCLYData.ztywList" :key="index" v-if="index > 0">
									<img width="345" height="560" :src="item.cover" @mouseenter="themeCur = index"
										@click="gotoImgTextDetail(item.id)" />
									<div class="imgText">
										<h5>{{ item.title }}</h5>
										<div class="">{{ item.description }}</div>
									</div>
								</swiper-slide>
							</Swiper>
							<div class="swiperBtn2">
								<div class="swiper-button-prev" slot="button-prev"></div>
								<div class="swiper-button-next" slot="button-next"></div>
							</div>
						</div>
					</div>
				</div>

				<div class="themeView"
					style="padding: 15px; background-color: #FAFAFA;margin-top: 30px;padding-bottom: 50px;padding-top: 30px;"
					v-else>
					<h4>主题游玩</h4>
					<p style="margin-top: 20px;">
						约你游主题活动旨在满足团体聚会/生日派对/企业团建/家庭活动/亲子研学等不同应用场景下的游玩需求，无论是短途、周边、省内或是国内、国际出游，约你游均可提供不同类型的房旅解决方案。</p>
					<div class="">
						<!-- <div class="themeView_box" v-for="(item, index) in  FCLYData.ztywList" :key="index">
							<img width="100%" height="180" :src="item.cover" @mouseenter="themeCur = index"
								@click="gotoImgTextDetail(item.id)" />
							<div class="imgText">
								<h5>{{ item.title }}</h5>
								<div class="">{{ item.description }}</div>
							</div>
						</div> -->
						<div class="swiperView">
							<Swiper class="my-swipe swiper" :options="swiperOption">
								<swiper-slide class="themeView_box" v-for="(item, index) in  FCLYData.ztywList" :key="index"
									v-if="index > 0">
									<img width="100%" height="180" :src="item.cover" @mouseenter="themeCur = index"
										@click="gotoImgTextDetail(item.id)" />
									<div class="imgText">
										<h5>{{ item.title }}</h5>
										<div class="">{{ item.description }}</div>
									</div>
								</swiper-slide>
							</Swiper>
							<!-- <div class="swiper-pagination"></div> -->
							<!-- <div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div> -->
						</div>
					</div>
				</div>
				<div class="campView">
					<div class="campView_box" v-if="windowWidth > 768">
						<div class=" relative">
							<img width="480" height="460" src="../../static/img/function/ic_kuang.png" />
							<img class="campImg" width="436" height="440" :src="FCLYData.lydtjList[campCur].cover"
								v-if="FCLYData.lydtjList" />
						</div>
						<div class="campRight">
							<h4 class="text-left">露营地推荐</h4>
							<div class="camp_view">
								<div class="camp_item flex flex-row align-center" :class="campCur == index ? 'active' : ''"
									v-for="(  item, index  ) in   FCLYData.lydtjList  " :key="index"
									@click="campCur = index">
									<img width="75" height="65"
										:src="campCur == index ? '../../static/img/function/ic_active.png' : '../../static/img/function/ic_noactive.png'" />
									<div class="text-222 text-left" style="margin-left: 26px;">
										<div style="font-size: 20px;">{{ item.title }}</div>
										<div>{{ item.description }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="campView_box relative padding-bottom" v-else>
						<h4 class="text-center margin-top" style="font-size: 20px !important;">露营地推荐</h4>
						<div class="" style="position: absolute;left: 15px;top: 60px;z-index: -1;">
							<img width="240" height="230" src="../../static/img/function/ic_kuang.png" />
						</div>
						<div class="camp_view">
							<div class="text-center margin-right" v-for="(  item, index  ) in FCLYData.lydtjList "
								:key="index">
								<img class="campImg" width="218" height="220" :src="item.cover" />
								<div class="camp_item flex flex-row align-center justify-center margin-top-sm">
									<img width="37.5" height="32.5" src="../../static/img/function/ic_active.png" />
									<div class="text-222 text-left" style="margin-left: 13px;max-width: 160px;">
										<div class="text-cut" style="font-size: 12px;">{{ item.title }}</div>
										<div class="text-cut" style="font-size: 10px;">{{ item.description }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<img width="100%" src="../../static/img/function/ic_bottomImg.png" v-if="windowWidth > 768" />
					<img width="100%" src="../../static/img/function/ic_bottomImg1.png" v-else />
				</div>
			</div>
			<!--沉浸文旅-->
			<div class="" id="title2" v-else-if="i == 1">
				<div class="dramaView text-222" v-if="windowWidth > 768">
					<h4>剧游神州介绍</h4>
					<div class=" margin-top">
						剧游神州，是沉浸文旅的专业运营平台，基于集团先进的研发技术团队与其他产业支撑，创建了专业运营剧情文旅的SAAS系统与创作者联盟，为创作者提供合作、交流、转化的内容服务，为景区提供定制剧本的综合平台管理服务，为合作商家提供专业可靠的剧本服务。
					</div>
					<div class="flex flex-row justify-between margin-top-lg">
						<div class="img-box" v-if="CQWLData.jyszList && CQWLData.jyszList.length > 0">
							<div class="img-box-inner">
								<img class="firstPlay" @click="playVedio(nameId(0), 0)" :src="CQWLData.jyszList[0].cover"
									alt="">
								<img @click="playVedio(nameId(0), 0)" class="play_btn" width="50"
									src="../../static/img/service/ic_play.png" />
								<img class="codeImg" src="../../static/img/function/ic_code.png" />
							</div>
							<div class="video_box" v-show="0 == n">
								<video id="id0" class="video_view" controls="controls">
									<source :src="CQWLData.jyszList[0].mediaUrl" type="video/ogg">
									<source :src="CQWLData.jyszList[0].mediaUrl" type="video/mp4">
									Your browser does not support the video tag.
								</video>
								<img class="stopBtn" width="50" height="50" src="../../static/img/index/ic_stop.png"
									@click.stop="stopPlay(nameId(0))" />
							</div>
						</div>
						<div class="text-222 dramaRight shadow">
							<h4>剧游神州活动</h4>
							<div class="rightPlayView">
								<div class="rightPlayItem" v-for="(  item, index  ) in   CQWLData.jyszList  " :key="index"
									v-if="index > 0">
									<div class="rightPlayViewLeft">
										<img class="rightPlayImg" width="150" height="90"
											@click="playVedio(nameId(index), index)" :src="item.cover" alt="">
										<img @click="playVedio(nameId(index), index)" class="play_btn" width="32"
											src="../../static/img/service/ic_play.png" />
									</div>
									<div class="playLeftText">
										<div class="text-222">{{ item.title }}</div>
										<div class="text-666" style="margin-top:16px;font-size: 14px;">{{
											formatDate(item.releaseDate) }}
										</div>
									</div>
									<div class="video_box" v-show="index == n">
										<video :id="nameId(index)" class="video_view" controls="controls">
											<source :src="item.mediaUrl" type="video/ogg">
											<source :src="item.mediaUrl" type="video/mp4">
											Your browser does not support the video tag.
										</video>
										<img class="stopBtn" width="50" height="50" src="../../static/img/index/ic_stop.png"
											@click.stop="stopPlay(nameId(index))" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="dramaView text-222 margin-lr-sm" v-else>
					<h4 class="text-left margin-top" style="font-size: 20px !important;">剧游神州介绍</h4>
					<div class="margin-top-xs text-666 text-left">
						剧游神州，是沉浸文旅的专业运营平台，基于集团先进的研发技术团队与其他产业支撑，创建了专业运营剧情文旅的SAAS系统与创作者联盟，为创作者提供合作、交流、转化的内容服务，为景区提供定制剧本的综合平台管理服务，为合作商家提供专业可靠的剧本服务。
					</div>
					<div class="margin-top-sm">
						<div class="img-box" v-if="CQWLData.jyszList && CQWLData.jyszList.length > 0">
							<div class="img-box-inner">
								<img class="firstPlay" @click="playVedio(nameId(0), 0)" :src="CQWLData.jyszList[0].cover"
									alt="">
								<img @click="playVedio(nameId(0), 0)" class="play_btn" width="50"
									src="../../static/img/service/ic_play.png" />
								<img class="codeImg" src="../../static/img/function/ic_code.png" />
							</div>
							<div class="video_box" v-show="0 == n">
								<video id="id0" class="video_view" controls="controls">
									<source :src="CQWLData.jyszList[0].mediaUrl" type="video/ogg">
									<source :src="CQWLData.jyszList[0].mediaUrl" type="video/mp4">
									Your browser does not support the video tag.
								</video>
								<img class="stopBtn" width="50" height="50" src="../../static/img/index/ic_stop.png"
									@click.stop="stopPlay(nameId(0))" />
							</div>
						</div>
						<div class="text-222 dramaRight">
							<!-- <h4>剧游神州活动</h4> -->
							<div class="rightPlayView">
								<div class="rightPlayItem margin-right-xs"
									v-for="(  item, index  ) in   CQWLData.jyszList  " :key="index" v-if="index > 0">
									<div class="rightPlayViewLeft">
										<img class="rightPlayImg" width="132" height="80"
											@click="playVedio(nameId(index), index)" :src="item.cover" alt="">
										<img @click="playVedio(nameId(index), index)" class="play_btn" width="24"
											src="../../static/img/service/ic_play.png" />
									</div>
									<div class="playLeftText">
										<div class="text-222 text-cut" style="font-size: 14px;margin-top: 10px;">{{
											item.title }}</div>
										<div class="text-666" style="font-size: 12px;margin-top: 5px;">{{
											formatDate(item.releaseDate) }}
										</div>
									</div>
									<div class="video_box" v-show="index == n">
										<video :id="nameId(index)" class="video_view" controls="controls">
											<source :src="item.mediaUrl" type="video/ogg">
											<source :src="item.mediaUrl" type="video/mp4">
											Your browser does not support the video tag.
										</video>
										<img class="stopBtn" width="50" height="50" src="../../static/img/index/ic_stop.png"
											@click.stop="stopPlay(nameId(index))" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="middleContent2">
					<div class="middleContent2_box" v-if="windowWidth > 768">
						<div class="titleView">
							<h4>合作共赢</h4>
							<div class="typeList">
								<div class="type_item" :class="{ active: typeCur == 0 }" @click="typeCur = 0">
									<p>合作景区</p>
								</div>
								<div class="type_item" :class="{ active: typeCur == 1 }" @click="typeCur = 1">
									<p>剧本案例</p>
								</div>
							</div>
						</div>
						<div class="areaView" v-if="typeCur == 0">
							<div class="flex flex-wrap flex-row" style="margin-top: 40px;">
								<div class="areaItem" v-for="(  item, index  ) in   CQWLData.hzjqList  " :key="index"
									@click="gotoScenicDetail(item.id)">
									<img width="345" height="250" :src="item.cover" />
									<div class="text-222 margin-top-xs text-cut">{{ item.title }}</div>
								</div>
							</div>
						</div>
						<div class="areaView" v-if="typeCur == 1">
							<div class="flex flex-wrap flex-row" style="margin-top: 40px;">
								<div class="areaItem" v-for="(  item, index  ) in   CQWLData.jbalList  " :key="index"
									@click="gotoPlayDetail(item.id)">
									<img width="345" height="250" :src="item.cover" />
									<div class="text-222 margin-top-xs text-cut">{{ item.title }}</div>
								</div>
							</div>
						</div>
					</div>

					<div class="middleContent2_box" v-else>
						<div class="titleView">
							<h4 style="font-size: 20px !important;">合作共赢</h4>
							<div class="typeList">
								<div class="type_item" :class="{ active: typeCur == 0 }" @click="typeCur = 0">
									<p>合作景区</p>
								</div>
								<div class="type_item" :class="{ active: typeCur == 1 }" @click="typeCur = 1">
									<p>剧本案例</p>
								</div>
							</div>
						</div>
						<div class="areaView" v-if="typeCur == 0">
							<div class="flex flex-wrap flex-row justify-between" style="margin-top:12px;">
								<div class="areaItem" v-for="(  item, index  ) in   CQWLData.hzjqList  " :key="index"
									@click="gotoScenicDetail(item.id)">
									<img :src="item.cover" />
									<div class="text-222 margin-top-xs">{{ item.title }}</div>
								</div>
							</div>
						</div>
						<div class="areaView" v-if="typeCur == 1">
							<div class="flex flex-wrap flex-row justify-between" style="margin-top: 12px;">
								<div class="areaItem" v-for="(  item, index  ) in   CQWLData.jbalList  " :key="index"
									@click="gotoPlayDetail(item.id)">
									<img :src="item.cover" />
									<div class="text-222 margin-top-xs">{{ item.title }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--通航体验-->
			<div id="title3" v-else-if="i == 2">
				<div class="topContent">
					<h4>通航体验介绍</h4>
					<div class="text-222 margin-top-sm">
						湖南远程天翼通用航空有限公司成立于2020年11月26日，目前公司拥有罗宾逊R44轻型直升机一台
						，公司位于湖南长沙·约你游（长沙）房车露营飞行基地，主要开展飞行体验、空中游览、个人娱乐飞行、航拍航测、空中广告、培私用和商用飞行驾驶执照以及各种商务项目合作等通用航空相关服务。
					</div>
					<div class="airTip">
						<div class="">
							<div class="airTipNum" style="color: #0C8C69;">630+</div>
							<div class="text-666 airTipNumTip">飞行架次(次)</div>
						</div>
						<div class="">
							<div class="airTipNum" style="color: #0C8C69;">1200+</div>
							<div class="text-666 airTipNumTip">服务用户(人)</div>
						</div>
						<div class="">
							<div class="airTipNum" style="color: #0C8C69;">12000+</div>
							<div class="text-666 airTipNumTip">飞行距离(km)</div>
						</div>
						<div class="">
							<div class="airTipNum" style="color: #0C8C69;">7500+</div>
							<div class="text-666 airTipNumTip">累计飞行时间(分钟)</div>
						</div>
					</div>
				</div>
				<div class="airHistory">
					<div class="airHistoryBox">
						<div class="historyText text-left flex-sub">
							<h4 class="text-df">发展历程</h4>
							<div class="margin-top-xs" style="line-height: 1.7;">迄今为止
								<br />
								展翅翱翔，追梦蓝天的梦想触手可及。
								<br />
								公司将立足当前，着眼长远，
								<br />
								开启另一全新、高端领域的探索旅行
							</div>
						</div>

						<div class="airBox" v-if="windowWidth <= 768">
							<div class="airHistoryView">
								<div class="airItem" v-for="(  item, index  ) in   historyData  " :key="index">
									<img width="13" src="../../static/img/function/ic_yuan1.png" />
									<div class="airText text-left" style="margin-left: 16px;">
										<div class="text-222" v-if="item.date">{{ formatDate(item.date) }}</div>
										<div class="text-999" style="font-size: 12px;">{{ item.content }}</div>
									</div>
								</div>
							</div>
						</div>

						<div class="swiperView" v-if="windowWidth > 768">
							<Swiper class="my-swipe swiper" :options="swiperOption31">
								<swiper-slide v-for="(item, index) in historyData" :key="index"> <img class="shadow"
										:width="windowWidth > 768 ? 520 : 300" :height="windowWidth > 768 ? 350 : 200"
										:src="item.image" /></swiper-slide>
							</Swiper>
							<div class="swiperBtn" v-if="windowWidth > 768">
								<div class="swiper-button-prev" slot="button-prev" style="z-index: 11;"></div>
								<div class="swiper-pagination"></div>
								<div class="swiper-button-next" slot="button-next"></div>
							</div>

							<div class="airBox" v-if="windowWidth > 768">
								<div class="airHistoryView">
									<div class="airItem" v-for="(item, index) in historyData" :key="index">
										<img width="16" src="../../static/img/function/ic_yuan.png" />
										<div class="airText text-left" style="margin-left: 16px;">
											<div class="text-white" v-if="item.date">{{ formatDate(item.date) }}</div>
											<div class="text-999" style="font-size: 12px;">{{ item.content }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div class="swiperView" v-if="windowWidth<=768">
							<Swiper class="my-swipe swiper" :options="swiperOption31">
								<swiper-slide v-for="(item, index) in historyData" :key="index"> <img class="shadow"
										:width="windowWidth > 768 ? 520 : 300" :height="windowWidth > 768 ? 350 : 200"
										:src="item.image" /></swiper-slide>
							</Swiper>
						</div>
				</div>
			</div>
			<!--APP下载-->
			<div class="appContent" v-else-if="i == 3">
				<h4>去约你游客户端享优惠</h4>
				<div class="appDownload flex flex-row justify-between">
					<div class="relative appDownImg">
						<img class="downLoadIos" src="../../static/img/function/ic_ios.png" @mouseenter="isShowCur = 0"
							@mouseleave="isShowCur = -1" />
						<img class="iosImg" width="200" src="../../static/img/index/ic_code.png" v-if="isShowCur == 0" />
					</div>
					<div class="relative appDownImg">
						<img class="downLoadAnd" src="../../static/img/function/ic_and.png" @mouseenter="isShowCur = 1"
							@mouseleave="isShowCur = -1" />
						<img class="andImg" width="200" src="../../static/img/index/ic_code.png" v-if="isShowCur == 1" />
					</div>
				</div>
				<img class="appImg"
					:src="windowWidth > 768 ? '../../static/img/function/appImg.png' : '../../static/img/function/appImg1.png'" />
				<div :class="windowWidth > 768 ? 'funView flex flex-row justify-between' : 'funView'">
					<div :class="windowWidth > 768 ? 'funItem' : 'flex funItem'"
						v-for="(  item, index  ) in   functionList  " :key="index">
						<img :width="windowWidth > 768 ? 137 : 49" :height="windowWidth > 768 ? 137 : 49" :src="item.img" />
						<div :class="windowWidth > 768 ? '' : 'margin-left-sm'">
							<div style="color: #0C8C69; font-size: 20px;margin: 20px 0;" v-if="windowWidth > 768">{{
								item.title }}</div>
							<div style="color: #0C8C69; font-size: 16px;" v-else>{{ item.title }}</div>
							<div class="text-222" style="font-size: 13px;">{{ item.text }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import cxHead from '@/components/cx-head.vue';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Swiper2, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";
Swiper2.use([Navigation, Pagination, EffectFade, Autoplay]);
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		cxHead,
	},
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: 'keyWords',
					content: this.SeoKeyword,
				},
				{
					name: 'description',
					content: this.SeoDescription,
				},
			],
		};
	},
	data() {
		//这里存放数据
		return {
			isFixed: false,
			isShowCur: -1,
			windowWidth: window.innerWidth,
			pageName: '',
			SeoKeyword: '',
			SeoDescription: '',
			i: 0,
			themeCur: 2,
			typeCur: 0,
			campCur: 0,
			lineCur: 0,
			n: -1,
			lineBgColor: ['#E1E5E8', '#E7E0D5', '#ECEBE2', '#E3E9EE', '#E8F0F7', '#E1E5E8', '#E7E0D5', '#ECEBE2', '#E3E9EE', '#E8F0F7', '#E1E5E8', '#E7E0D5', '#ECEBE2', '#E3E9EE', '#E8F0F7'],
			mianbaoList: [
				{
					label: '房车露营',
					path: '#',
					id: '#title1',
				},
				{
					label: '沉浸文旅',
					path: '#',
					id: '#title2',
				},
				{
					label: '通航体验',
					path: '#',
					id: '#title3',
				},
				{
					label: 'APP下载',
					path: '#',
					id: '#title4',
				}
			],
			functionList: [
				{
					img: '../../static/img/function/1.png',
					title: '房车租赁',
					text: '简单三步完成房车租用',
				},
				{
					img: '../../static/img/function/2.png',
					title: '营地预定',
					text: '提前看好落脚点,全国营地都能定',
				},
				{
					img: '../../static/img/function/3.png',
					title: '定制线路',
					text: '你提需求，我做设计,出去玩就要省心省力',
				},
				{
					img: '../../static/img/function/4.png',
					title: '主题活动',
					text: '毕业季/亲子游/生日趴/亲密聚会等不同主题',
				},
				{
					img: '../../static/img/function/5.png',
					title: '游记分享',
					text: '一键分享出游好心情',
				}
			],
			swiperOption31: {

				slidesPerView: window.innerWidth > 768 ? 1.8 : 1.3,
				spaceBetween: window.innerWidth > 768 ? 20 : 15,
				// slidesPerView: 1,
				// loop: true,
				width: window.innerWidth > 768 ? 1040 : 414,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						console.log('轮播图滚动事件  --->');
					},
				},
			},

			swiperOption32: {
				slidesPerView: 1.3,
				spaceBetween: 15,
				// slidesPerView: 1,
				// loop: true,
				width: 414,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						console.log('轮播图滚动事件  --->');
					},
				},
			},

			swiperOption0: {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 500,
				// },
				slidesPerView: window.innerWidth > 768 ? 4 : 5.4,
				spaceBetween: window.innerWidth > 768 ? 0 : 10,
				// slidesPerView: 1,
				// loop: true,
				// width: 1040,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				// pagination: {
				// 	el: ".swiper-pagination",
				// 	type: "fraction",
				// },
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						console.log('轮播图滚动事件  --->');
					},
				},
			},

			swiperOption: {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 500,
				// },
				slidesPerView: window.innerWidth > 768 ? 4 : 1.2,
				spaceBetween: 20,
				// slidesPerView: 1,
				// loop: true,
				// width: 1040,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				// pagination: {
				// 	el: ".swiper-pagination",
				// 	type: "fraction",
				// },
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						console.log('轮播图滚动事件  --->');
					},
				},
			},
			FCLYData: {},//房车露营数据
			CQWLData: {},//沉浸文旅数据
			historyData: []//通航发展历程
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		Scroll(e) {
			let scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
			console.log(scrollTop);
			if (scrollTop > 620) {
				this.isFixed = true;
			} else {
				this.isFixed = false;
			}
		},
		gotoImgTextDetail(id) {//跳转主题活动
			this.$router.push({
				path: '/themeDetail',
				query: { id: id },
			});
		},
		gotoScenicDetail(id) {//跳转景区详情
			this.$router.push({
				path: '/scenicDetail',
				query: { id: id },
			});
		},
		gotoPlayDetail(id) {//跳转剧本详情
			this.$router.push({
				path: '/playDetail',
				query: { id: id },
			});
		},

		formatDate(date) { //格式化日期
			if (date) {
				let date1 = new Date(date.replace(/-/g, '/'));
				date = this.common.formatDate(new Date(date1), 'yyyy年MM月dd日');
			}
			return date;
		},

		nameId(index) {
			return 'id' + index;
		},
		playVedio(id, index) {
			// console.log(id)
			this.n = index;
			// this.mp4 = '../../static/mp4/2.mp4';
			// this.$set(this.mp4, 0, '../../static/mp4/2.mp4');
			var video = document.querySelector('#' + id);
			// video.play();
		},
		stopPlay(id) {
			// console.log(id)
			this.n = -1;
			// this.mp4 = '../../static/mp4/2.mp4'
			var video = document.querySelector('#' + id);
			video.pause();

		},
		goAnchor(index) {//切换tab
			this.i = index;
			sessionStorage.setItem("tabCur", index);
			//跳转锚点
			// var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id
			// document.body.scrollTop = anchor.offsetTop - 100; // chrome
			// document.documentElement.scrollTop = anchor.offsetTop - 100; // firefox
		},
		getSiteData() {
			//获取seo关键字
			let that = this;
			that.$axios
				.post(api.GetSiteData, {})
				.then(function (response) {
					// console.log('seo优化', response);
					let data = response.data;
					that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
					that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
					that.SeoDescription = data.SeoDescription
						? data.SeoDescription
						: '约你游·一站式房车旅游综合服务平台';
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		getFCLYMediaData() {//获取房车露营数据
			let that = this;
			this.$axios
				.post(api.GetFCLYMediaData, {})
				.then(function (response) {
					let data = response.data
					if (data.code == 200) {
						// console.log('更多数据', response);
						that.FCLYData = data.data;
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		getCQWLMediaData() {//获取沉浸文旅数据
			let that = this;
			this.$axios
				.post(api.GetCQWLMediaData, {})
				.then(function (response) {
					let data = response.data
					if (data.code == 200) {
						// console.log('更多数据', response);
						that.CQWLData = data.data;
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		getCompanyYCTYData() {//获取通航发展历程
			let that = this;
			this.$axios
				.post(api.GetCompanyYCTYData, { page: 1, rows: 99 })
				.then(function (response) {
					let data = response.data;
					that.historyData = data.data;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getFCLYMediaData();
		this.getCQWLMediaData();
		this.getCompanyYCTYData();
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		window.addEventListener('scroll', this.Scroll, true);
		this.getSiteData();
		if (this.$route.query.id) {
			let id = this.$route.query.id;
			this.i = id;
		}
		let tabCur = sessionStorage.getItem("tabCur");
		console.log('缓存', tabCur)
		if (tabCur) {
			this.i = tabCur;
		}


	},
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { }, //生命周期 - 更新之后
	beforeDestroy() {
		window.removeEventListener('scroll', this.Scroll, true);
	}, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
/* //@import url(); 引入公共css类 */
.content {
	padding-bottom: 90px;
}

.container-fluid {
	padding-left: 0 !important;
	padding-right: 0 !important;
}

.mianbao {
	/* // display: flex;
		// flex-direction: row;
		// align-items: center; */
	background: #fbfbfb;
	font-size: 16px;
	padding-top: 15px;

}

.isFixed {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 9999;
}

.mianbao_view {
	width: 100%;
	max-width: 1480px;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;

	.active {
		/* // font-weight: bold; */
		border-bottom: 2px solid #0C8C69
	}
}

@media (min-width: 768px) {

	/* // .mianbao {
		// 	padding-left: 200px;
		// } */
	.mianbao_min {
		display: none;
	}

	.function {
		max-width: 1440px;
		width: 100%;
		margin: 0 auto;
		margin-top: 100px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		.functionRight {
			margin-left: 57px;

			.lineBox {
				width: 132px;
				height: 170px;
				text-align: center;
				padding-top: 20px;
				// margin-right: 6px;

				img {
					border-radius: 100%;
					margin-bottom: 10px;
				}
			}

			.swiperBtn0 {
				position: absolute;
				width: 128%;
				top: 42px;
				left: -14.5%;

				.swiper-button-next:after,
				.swiper-button-prev:after {
					font-size: 24px;
					color: #999;
				}
			}
		}
	}

	.themeView {
		width: 100%;
		background-color: #F8F8F8;
		/* // padding: 86px 240px 0 240px; */
		padding-top: 86px;
		margin-top: 100px;

		.themeView_box {
			max-width: 1440px;
			width: 100%;
			margin: 0 auto;
			overflow-x: auto;
			position: relative;

			.swiperBtn2 {
				/* // position: inherit;
					// width: 108%;
					// left: -4%;
					// top: -152px; */

				.swiper-button-next:after,
				.swiper-button-prev:after {
					font-size: 32px;
					color: #07BF91;
				}
			}
		}

		.themeImg_box {
			position: relative;
			margin-top: 70px;
			cursor: pointer;

			.imgText {
				color: #fff;
				position: absolute;
				top: 20px;
				left: 15px;
				text-align: left;
			}
		}


		p {
			width: 100%;
			max-width: 1200px;
			margin: 0 auto;
			/* // margin-top: 40px; */
			line-height: 2;
			color: #222;
			font-size: 16px;
		}

		.themeImg {
			margin-right: 12px;
			/* // margin-top: 70px; */
		}
	}

	.campView {
		/* // padding: 126px 0 130px 340px; */
		padding: 126px 0;

		.campView_box {
			display: flex;
			flex-direction: row;
			align-content: center;
			max-width: 1240px;
			width: 100%;
			margin: 0 auto;
		}

		.campImg {
			position: absolute;
			top: 56px;
			left: 64px;
		}

		.campRight {
			margin-left: 87px;
			width: 680px
		}

		.camp_view {
			margin-top: 30px;
		}

		.camp_item {
			padding: 30px 0 26px 30px;
			margin-top: 30px;
			cursor: pointer;
		}

		.active {
			border-radius: 10px;
			box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
			background-color: #fff;
		}
	}

	.dramaView {
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		margin-top: 29px;
		text-align: left;

		.img-box {
			/* // height: 200px;
				// background-color: #cccccc; */
			position: relative;
			width: 985px;
			height: 575px;
			cursor: pointer;

			.play_btn {
				position: absolute;
				top: 50%;
				left: 50%;
				width: 50px;
				height: 50px;
				margin-top: -25px;
				margin-left: -25px;
			}

			.codeImg {
				position: absolute;
				width: 120px;
				height: 120px;
				bottom: 20px;
				right: 20px;
			}

			.img-box-inner,
			.firstPlay {
				width: 100%;
				height: 575px;
				overflow: hidden;
				transition: all 0.8s;
				position: relative;
			}
		}

		.dramaRight {
			width: 413px;
			height: 575px;
			padding: 25px 25px;
			border-radius: 10px;

			/* // display: flex; */
			.rightPlayView {
				overflow-y: auto;
				height: 480px;

				.rightPlayItem {
					margin-top: 20px;
					display: flex;
					flex-direction: row;
					cursor: pointer;

					.rightPlayViewLeft {
						position: relative;
					}

					.play_btn {
						position: absolute;
						top: 50%;
						left: 50%;
						width: 30px;
						height: 30px;
						margin-top: -15px;
						margin-left: -15px;
					}

					.playLeftText {
						margin-left: 20px;
					}
				}
			}
		}
	}

	.middleContent2 {
		width: 100%;
		padding: 70px 240px;
		background-color: #F8F8F8;
		margin-top: 100px;

		.middleContent2_box {
			max-width: 1440px;
			margin: 0 auto;

		}

		h4 {
			text-align: left;
		}

		.typeList {
			display: flex;
			flex-direction: row;
			margin-top: 40px;

			.type_item {
				text-align: center;
				border-bottom: 3px solid #F8F8F8;
				font-size: 20px;
				margin-right: 30px;
			}

			.active {
				border-bottom: 3px solid #0C8C69;
				color: #0C8C69;
			}
		}

		.areaItem {
			margin: 0 7.5px;
			margin-top: 20px;
			// margin-right: 15px;
			cursor: pointer;
		}
	}

	.topContent {
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		margin-top: 80px;

		.airTip {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			max-width: 940px;
			margin: 0 auto;
			margin-top: 50px;

			.airTipNum {
				font-size: 40px;
			}
		}
	}

	.airHistory {
		background: url('../../static/img/function/airBg.png') no-repeat;
		width: 100%;
		height: auto;
		background-size: 100% auto;
		background-position: center center;
		padding: 70px 0 80px 0px;
		margin-top: 60px;
		position: relative;
		display: flex;
		justify-content: end;

		.airHistoryBox {
			max-width: 1440px;
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin: 0 auto;

			.historyText {
				// margin-left: 240px;
			}

		}

		.swiperView {
			position: relative;
			// flex: 1;
			max-width: 1040px;
			width: 100%;

			.swiperBtn {
				position: absolute;
				bottom: -25px;
				color: #999;
				width: 120px;
				height: 40px;
				left: 240px;

				.swiper-button-next:after,
				.swiper-button-prev:after {
					font-size: 12px;
					color: #999;
				}

				// .swiper-button-next:after{
				// 	content: '\2192';
				// }
				// .swiper-button-prev:after{
				// 	content: '\2190';
				// }
			}
		}

		.my-swipe {
			margin-top: 30px;
			padding: 20px 0;

			.swiperImg {
				box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
				// box-shadow:0px 0px 15px 5px rgba(0, 0, 0, 1)
			}
		}

		.airBox {
			position: absolute;
			background-color: #4D4948;
			// padding: 15px;
			overflow-y: auto;
			height: 260px;
			width: 260px;
			top: 180px;
			z-index: 1;
			left: -40px;

			.airHistoryView {
				border-left: 1px dashed #FFFFFF;
				margin: 15px;
			}

			.airItem {
				display: flex;
				margin-left: -9px;
				margin-top: 15px;

				img {
					width: 16px;
					height: 16px;
					margin-top: 3px;
				}
			}
		}

	}

	.appContent {
		width: 100%;
		max-width: 1320px;
		margin: 0 auto;
		margin-top: 90px;
		text-align: center;

		h4 {
			font-size: 40px !important;
		}

		.appDownload {
			max-width: 564px;
			margin: 0 auto;
			margin-top: 50px;

			.iosImg,
			.andImg {
				position: absolute;
				top: 72px;
				left: 23px;
			}
		}

		.downLoadIos,
		.downLoadAnd {
			width: 247px;
			height: 60px;
		}

		.appImg {
			width: 916px;
			margin-top: 60px;
			margin-bottom: 120px;
		}

		.funItem {
			max-width: 137px;
			text-align: center;
		}
	}

	.video_box {
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		text-align: center;

		.stopBtn {
			position: absolute;
			right: 20px;
			top: 60px;
			z-index: 2;
		}
	}

	.video_view {
		width: 100%;
		height: 100%;
		// margin-top: 200px;
	}
}


@media (max-width: 768px) {
	.mianbao {
		padding-top: 0;
	}

	.mianbao_min {
		display: flex;
		height: 40px;
		line-height: 35px;
		background-color: #FBFBFB;
		// padding-left: 15px;
		justify-content: space-around;
		text-align: center;
		font-size: 14px;

		.active {
			border-bottom: 2px solid #0C8C69;
			color: #0C8C69;
		}
	}


	.content {
		width: 100%;
		/* position: absolute; */
		padding-bottom: 20px;
	}

	.video_box {
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;

		.stopBtn {
			position: absolute;
			right: 20px;
			top: 60px;
			z-index: 2;
		}
	}

	.video_view {
		width: 100%;
		margin-top: 50%;
		height: 50%;
	}

	.lineBox {
		width: 66px;
		height: 84px;
		text-align: center;
		padding-top: 10px;
		/* margin-right: 6px; */

		img {
			border-radius: 100%;
			margin-bottom: 5px;
		}
	}

	.lineBox_active {
		border: 2px solid #23B78F;
	}

	.lineBox_noactive {
		border: 2px solid #fff;
	}

	.themeView_box {
		position: relative;
		margin-top: 25px;
		cursor: pointer;

		.imgText {
			color: #fff;
			position: absolute;
			top: 20px;
			left: 15px;
			text-align: left;
		}
	}

	.camp_view {
		display: flex;
		overflow-x: auto;
		padding-left: 47px;
		margin-top: 58px;
	}

	.dramaView {
		/* width: 100%; */
		/* margin: 0 auto; */
		/* margin-top: 29px; */
		text-align: left;

		.img-box {
			/* // height: 200px;
				// background-color: #cccccc; */
			position: relative;
			/* height: 575px; */
			cursor: pointer;

			.play_btn {
				position: absolute;
				top: 50%;
				left: 50%;
				width: 50px;
				height: 50px;
				margin-top: -25px;
				margin-left: -25px;
			}

			.codeImg {
				position: absolute;
				width: 60px;
				height: 60px;
				bottom: 20px;
				right: 20px;
			}

			.img-box-inner,
			.firstPlay {
				width: 100%;
				/* height: 575px; */
				overflow: hidden;
				transition: all 0.8s;
				position: relative;
			}
		}

		.dramaRight {
			.rightPlayView {
				display: flex;
				overflow-x: auto;
				/* height: 480px; */

				.rightPlayItem {
					margin-top: 10px;
					cursor: pointer;

					.rightPlayViewLeft {
						position: relative;
					}

					.play_btn {
						position: absolute;
						top: 50%;
						left: 50%;
						width: 30px;
						height: 30px;
						margin-top: -15px;
						margin-left: -15px;
					}

					.playLeftText {
						/* margin-left: 20px; */
						max-width: 132px;
					}
				}
			}
		}
	}

	.middleContent2 {
		width: 100%;
		background-color: #F8F8F8;
		margin-top: 40px;
		padding: 20px 15px;

		.middleContent2_box {
			margin: 0 auto;
		}

		h4 {
			text-align: left;
		}

		.typeList {
			display: flex;
			flex-direction: row;
			margin-top: 20px;

			.type_item {
				text-align: center;
				border-bottom: 3px solid #F8F8F8;
				font-size: 16px;
				/* margin-right: 30px; */
				flex: 1;
			}

			.active {
				border-bottom: 3px solid #0C8C69;
				color: #0C8C69;
			}
		}

		.areaItem {
			width: calc(50% - 6px);
			/* margin: 0 7.5px; */
			margin-top: 15px;

			img {
				width: 100%;
				height: 125px;
				border-radius: 5px;
			}
		}
	}

	.topContent {
		width: 100%;
		margin-top: 30px;
		padding: 0 15px;

		.airTip {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin-top: 30px;

			.airTipNum {
				font-size: 18px;
			}

			.airTipNumTip {
				font-size: 12px;
			}
		}
	}

	.airHistory {
		width: 100%;
		background-color: #F8F8F8;
		padding: 30px 15px;
		margin-top: 60px;
		position: relative;

		h4 {
			font-size: 20px !important;
		}

		.airHistoryBox {
			width: 100%;
			margin: 0 auto;

		}

		.swiperView {
			position: relative;
			width: 100%;

			.swiperBtn {
				position: absolute;
				bottom: -25px;
				color: #999;
				width: 120px;
				height: 40px;
				left: 240px;

				.swiper-button-next:after,
				.swiper-button-prev:after {
					font-size: 12px;
					color: #999;
				}
			}
		}

		.my-swipe {
			margin-top: 30px;
			padding: 20px 0;

			.swiperImg {
				box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
			}
		}

		.airBox {
			.airHistoryView {
				border-left: 0.5px dashed #666666;
				margin: 7px;
				margin-top: 30px;
			}

			.airItem {
				display: flex;
				margin-left: -7.5px;
				margin-top: 15px;

				img {
					width: 13px;
					height: 13px;
					margin-top: 3px;
				}
			}
		}

	}

	.appContent {
		width: 100%;
		/* max-width: 1320px; */
		margin: 0 auto;
		margin-top: 40px;
		text-align: center;

		h4 {
			font-size: 20px !important;
		}

		.appDownload {
			/* max-width: 564px; */
			margin: 0 auto;
			margin-top: 30px;
			padding: 0 17px;

			.iosImg,
			.andImg {
				position: absolute;
				top: 72px;
				left: 23px;
			}
		}

		.appDownImg {
			flex: 1;
			margin: 0 5px;
		}

		.downLoadIos,
		.downLoadAnd {
			width: 100%;
			height: 40px;
		}

		.appImg {
			margin-top: 30px;
			margin-bottom: 20px;
			width: calc(100% - 48px);
		}

		.funItem {
			/* max-width: 137px; */
			text-align: left;
			align-items: center;
			padding-left: 15px;
			margin-top: 18px;
		}
	}
}

.mianbao_item {
	margin: 0 20px;
	padding-bottom: 15px;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/page/function.vue